import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

interface MarketAccessibilitySectionProps {
  marketAccessibility: string;
  setMarketAccessibility: (value: string) => void;
  accessibilityLimitations: string[];
  setAccessibilityLimitations: (value: string[]) => void;
}

export const MarketAccessibilitySection = ({
  marketAccessibility,
  setMarketAccessibility,
  accessibilityLimitations,
  setAccessibilityLimitations,
}: MarketAccessibilitySectionProps) => {
  const limitationOptions = [
    "Competition",
    "Regulatory Barriers",
    "Customer Awareness",
    "Distribution Channels"
  ];

  return (
    <div className="space-y-4">
      <div>
        <Label>Market Accessibility Percentage</Label>
        <Input
          type="number"
          value={marketAccessibility}
          onChange={(e) => setMarketAccessibility(e.target.value)}
          placeholder="e.g., 25"
        />
      </div>

      <div>
        <Label>Accessibility Limitations</Label>
        <div className="grid grid-cols-2 gap-2 mt-2">
          {limitationOptions.map((limitation) => (
            <div key={limitation} className="flex items-center space-x-2">
              <Checkbox
                checked={accessibilityLimitations.includes(limitation)}
                onCheckedChange={(checked) => {
                  if (checked) {
                    setAccessibilityLimitations([...accessibilityLimitations, limitation]);
                  } else {
                    setAccessibilityLimitations(
                      accessibilityLimitations.filter((l) => l !== limitation)
                    );
                  }
                }}
              />
              <Label>{limitation}</Label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};